module.exports = __webpack_public_path__ + "static/media/info-circle-solid.463a1adc.svg";